import { useRouter as SolitoRouter } from 'solito/navigation';

const useRouter = () => {
  const { push: solitoPush, back } = SolitoRouter();

  const push = (url: string | { pathname: string; query?: Record<string, string> }) => {
    if (typeof url === 'string') {
      solitoPush(url);
    } else {
      const queryString = url.query ? '?' + new URLSearchParams(url.query).toString() : '';
      solitoPush(url.pathname + queryString);
    }
  };

  return { push, back };
};

export default useRouter;
